// this should contain the admin icons only
const items = [];

export { items };
